import { useState, useEffect } from 'react';
import { API_BASE } from '../../config';

/**
 * Custom hook to fetch route information
 * @param {string | null} routeId - Route ID to fetch
 * @returns {{ data: import('./routeInfo.types').RouteInfo | null, loading: boolean, error: string | null }}
 */
export const useRouteInfo = (routeId) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!routeId) {
      setData(null);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchRouteInfo = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(`${API_BASE}/api/routes/${routeId}/info`);
        
        if (!response.ok) {
          throw new Error(`Failed to fetch route info: ${response.status}`);
        }

        const routeData = await response.json();
        setData(routeData);
      } catch (err) {
        console.error('[useRouteInfo] Error fetching route info:', err);
        setError(err.message || 'Failed to load route information');
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchRouteInfo();
  }, [routeId]);

  return { data, loading, error };
};